// extracted by mini-css-extract-plugin
export var bounce = "_jz-1";
export var generatingText = "_jz-6";
export var lightning = "_jz-4";
export var popup = "_jz-5";
export var progressBar = "_jz-7";
export var progressFill = "_jz-8";
export var progressShimmer = "_jz-9";
export var progressText = "_jz-a";
export var shimmer = "_jz-3";
export var uploadIcon = "_jz-0";
export var uploadingText = "_jz-2";